import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "save-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createBlock(_Transition, {
    name: "fade-up"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["floating-save-btn", {
        'is-loading': $props.loading
      }]),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClick && $options.handleClick(...args))
    }, [$props.loading ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: 0,
      icon: "spinner",
      spin: ""
    })) : (_openBlock(), _createBlock(_component_font_awesome_icon, {
      key: 1,
      icon: "save"
    })), _createElementVNode("span", _hoisted_1, _toDisplayString($props.loading ? _ctx.$t('floatingSave.saving') : _ctx.$t('floatingSave.save')), 1)], 2), [[_vShow, $data.visible]])]),
    _: 1
  });
}